export class ClubModel {
  id: number = 0;
  club_name: string = 'GCETLY';
  address1: string = 'Marshal nagar Tirunelveli';
  address2: string = 'Tirunelveli';
  city: string = 'Tirunelveli';
  state: string = 'TN';
  zip: string = '627007';
  created_by: string = 'Abishek';
  club_label: string = 'abcxyz';
  total_league: number = 0;
  active_league: number = 0;
  teams: number = 0;
  registered_date: string = '2024-02-10T15:02:06.440Z';
}


export class MyClub {
  id!: number;
  name!: string;
  totalLeagues!: number;
  teams!: number;
  activeLeagues!: number;
  club_label!: string;
}
export class RegisteredClub {
  id!: number;
  club_name!: string;
  created_by!: string;
  join_date!: number;
  club_label!: string;
}
export class ClubMember {
  user_id!: number;
  first_name!: string;
  last_name!: string;
  email!: string;
  phone_number!: string;
  gender!: string;
  join_date!: string;
}

export interface IClub {
  id: number;
  clubName: string;
  address1: string;
  address2?: string;
  city: string;
  state: IState;
  sport: ISport;
  zip: string;
  createdBy: string;
  createdDate: string | Date;
  isAdmin?: boolean;
  noOfCurrentLeagues?: number;
  noOfLeagues?: number;
  noOfMatches?: number;
  noOfMembers?: number;
  noOfTeams?: number;
  homeCourt: ICourt;
  isApprove?: boolean;
  payments?: IPayment[];
  fees?: number;
  calculationType: ICalculationType | null;
}

export interface IPayment {
  paymentOption?: string;
  checked?: boolean;
  payTo?: string;
}

export interface ISport {
  id: number;
  name: string;
}
export interface ICalculationType {
  id: number;
  type: string;
  description: string;
}

export interface IState {
  id: number;
  code: string;
  name: string;
}

export interface ICourt {
  id: number;
  name: string;
}

export interface IClubInvite {
  clubId: number;
  email: string;
  isEmailSend: boolean;
  isRegistered: boolean;
  isValidUser: boolean;
}

export interface ILeagueInvite {
  leagueId: number;
  clubId: number;
  email: string;
  isEmailSend: boolean;
  isLeagueRegistered: boolean;
  isValidUser: boolean;
  userName: string;
}

export interface IUser {
  id: number;
  userName: string;
  firstName: string;
  lastName: string;
  password: string | null;
  email: string;
  phoneNumber: string;
  age: number;
  dateOfBirth: string;
  gender: string;
  zip: string;
  isSuccess: boolean;
  message: string | null;
  token: string | null;
}

export interface IState {
  id: number;
  code: string;
  name: string;
}

export interface ISport {
  id: number;
  name: string;
}

export interface IApproveClub {
  requestedUser: IUser;
  id: number;
  clubName: string;
  address1: string;
  address2: string;
  city: string;
  state: IState;
  sport: ISport;
  zip: string;
  createdBy: string | null;
  createdDate: string;
  isAdmin: boolean;
  isApprove: boolean;
  homeCourt: string | null;
}
